export default __webpack_public_path__ + "static/media/FitsImg.935ececf.jpg";